import { render, staticRenderFns } from "./repeatation-block.vue?vue&type=template&id=9fffb9aa"
import script from "./repeatation-block.vue?vue&type=script&lang=js"
export * from "./repeatation-block.vue?vue&type=script&lang=js"
import style0 from "./repeatation-block.vue?vue&type=style&index=0&id=9fffb9aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports